import PropTypes from "prop-types"
import SecuritiesFinder from "modules/securities-finder"

export default function SmartTradeSetup({ modelId, selectedDate, instrumentPortfolio }) {
  return <SecuritiesFinder
    modelId={modelId}
    noDateSelection
    selectedDate={selectedDate}
    allowFiltersToggle
    instrumentPortfolio={instrumentPortfolio}
    context={instrumentPortfolio ? "smart-portfolio" : "smart-trade"}
  />
}

SmartTradeSetup.propTypes = {
  modelId: PropTypes.string.isRequired,
  selectedDate: PropTypes.string.isRequired,
  instrumentPortfolio: PropTypes.object,
}
